import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Pages
import { Dashboard } from '../pages/Dashboard';
import { Settings } from '../pages/Settings';
import { Translations } from '../pages/Translations';
import { TranslationHistory } from '../pages/TranslationHistory';
import { Notifications } from '../pages/Notifications';
import { Resources } from '../pages/Resources';
import { Billing } from '../pages/Billing';
import { Login } from '../pages/Login';
import AuthCallback from '../pages/AuthCallback';
import { Install } from '../pages/Install';
import { TestBackend } from '../pages/TestBackend';

// Components
import { AppLayout } from '../components/AppLayout';
import { LoadingSpinner } from '../components/LoadingSpinner';

export const AppRoutes: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // If we are loading authentication status, show a spinner
  if (isLoading) {
    return <LoadingSpinner />;
  }

  // If we are authenticated, render the main app layout
  if (isAuthenticated) {
    return (
      <AppLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/translations" element={<Translations />} />
          <Route path="/history" element={<TranslationHistory />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/test-backend" element={<TestBackend />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AppLayout>
    );
  }

  // If not authenticated, show login routes
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/install" element={<Install />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}; 